import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Layout } from 'antd';
import HeaderComponent from './components/Header';
import Home from './pages/home';
import Detail from './pages/home/detail';
import { ConfigProvider } from "antd";
import { theme } from "./settings";

export default function App() {
  const [searchKeyword, setSearchKeyword] = useState('');

  // 搜索框的回调
  const handleSearch = (value) => {
    setSearchKeyword(value); // 更新搜索关键词
  };

  return (
    <ConfigProvider theme={theme}>
      <Router>
        <HeaderComponent onSearch={handleSearch} /> {/* 将搜索功能传递给Header组件 */}
        <Routes>
          <Route path="/" element={<Home searchKeyword={searchKeyword} />} />
          <Route path="/detail/:number" element={<Detail />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}
